import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var InvoicePdfListRes;
export const InvoicePdfListTodo = createAsyncThunk('InvoicePdfList', async (data) => {
    // console.log("data", data)
    const type = localStorage.getItem('type')
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'so_pdf',
            data: {
                "vinvoice_code": data
            },
            headers: { "Content-Type": "application/json" },

        })
        return InvoicePdfListRes = res.data

    } catch (error) {
        return InvoicePdfListRes = error.response.data
    }
});

const InvoicePdfListSlice = createSlice({
    name: 'InvoicePdfList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(InvoicePdfListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(InvoicePdfListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default InvoicePdfListSlice.reducer; 